import { InteractionsTotalMetric } from "../charts-metrics/InteractionsTotalMetric";
import { LevelPieChart } from "../charts-metrics/LevelPieChart";
import { ShelterExit7DayMetric } from "../charts-metrics/ShelterExit7DayMetric";
import { ShelterExit7DayTypeMetric } from "../charts-metrics/ShelterExit7DayTypeMetric";
import { ShelterInfractionsBarChart } from "../charts-metrics/ShelterInfractionsBarChart";
import { ShelterIntake7DayMetric } from "../charts-metrics/ShelterIntake7DayMetric";
import { ShelterOccupancyLineChart } from "../charts-metrics/ShelterOccupancyLineChart";
import { ShelterOccupancyPercentageMetric } from "../charts-metrics/ShelterOccupancyPercentageMetric";
import { ShelterOccupiedMetric } from "../charts-metrics/ShelterOccupiedMetric";
import { ShelterVacancyMetric } from "../charts-metrics/ShelterVacancyMetric";
import { GoalsCompletedMetric } from "../charts-metrics/GoalsCompletedMetric";
import { TasksCompletedMetric } from "../charts-metrics/TasksCompletedMetric";
import { InteractionsBarChart } from "../charts-metrics/InteractionsBarChart";
import { GoalsCompletedTable } from "../charts-metrics/GoalsCompletedTable";
import { TasksCompletedTable } from "../charts-metrics/TasksCompletedTable";
import { InteractionsTable } from "../charts-metrics/InteractionsTable";
import { JobsTable } from "../charts-metrics/JobsTable";
import { ProgramTable } from "../charts-metrics/ProgramTable";
import { ResourcesMetric } from "../charts-metrics/ResourcesMetric";
import { ResourcesAssignedTable } from "../charts-metrics/ResourcesAssignedTable";

export const dashboardMap: Record<
  string,
  { component: React.ComponentType<any>; defaultCols: string; maxCols: string; defaultProps?: object; useDateTimePicker?: boolean }
> = {
  interactions_all: {
    component: InteractionsTotalMetric,
    defaultCols: "2",
    maxCols: "3",
    useDateTimePicker: true,
  },
  interactions_by_type: {
    component: InteractionsTotalMetric,
    defaultCols: "3",
    maxCols: "4",
    defaultProps: { byType: true },
    useDateTimePicker: true,
  },
  infractions_bar_chart: {
    component: ShelterInfractionsBarChart,
    defaultCols: "6",
    maxCols: "9",
  },
  interactions_bar_chart: {
    component: InteractionsBarChart,
    defaultCols: "6",
    maxCols: "9",
    useDateTimePicker: true,
  },
  goals_completed: {
    component: GoalsCompletedMetric,
    defaultCols: "2",
    maxCols: "3",
    useDateTimePicker: true,
  },
  program_level_pie_chart: {
    component: LevelPieChart,
    defaultCols: "6",
    maxCols: "9",
  },
  shelter_7_day_exit: {
    component: ShelterExit7DayMetric,
    defaultCols: "2",
    maxCols: "3",
  },
  shelter_7_day_voluntary_exit: {
    component: ShelterExit7DayTypeMetric,
    defaultCols: "2",
    maxCols: "3",
    defaultProps: { exitType: "voluntary" },
  },
  shelter_7_day_involuntary_exit: {
    component: ShelterExit7DayTypeMetric,
    defaultCols: "2",
    maxCols: "3",
    defaultProps: { exitType: "involuntary" },
  },
  shelter_7_day_ban_exit: {
    component: ShelterExit7DayTypeMetric,
    defaultCols: "2",
    maxCols: "3",
    defaultProps: { exitType: "ban" },
  },
  shelter_7_day_intake: {
    component: ShelterIntake7DayMetric,
    defaultCols: "2",
    maxCols: "3",
  },
  shelter_30_day_occupancy: {
    component: ShelterOccupancyLineChart,
    defaultCols: "6",
    maxCols: "9",
  },
  shelter_occupancy_pct: {
    component: ShelterOccupancyPercentageMetric,
    defaultCols: "2",
    maxCols: "3",
  },
  shelter_occupied_beds: {
    component: ShelterOccupiedMetric,
    defaultCols: "2",
    maxCols: "3",
  },
  shelter_vacant_beds: {
    component: ShelterVacancyMetric,
    defaultCols: "2",
    maxCols: "3",
  },
  tasks_completed: {
    component: TasksCompletedMetric,
    defaultCols: "2",
    maxCols: "3",
    useDateTimePicker: true,
  },
  goals_completed_table: {
    component: GoalsCompletedTable,
    defaultCols: "8",
    maxCols: "12",
    useDateTimePicker: true,
  },
  tasks_completed_table: {
    component: TasksCompletedTable,
    defaultCols: "8",
    maxCols: "12",
    useDateTimePicker: true,
  },
  interactions_table: {
    component: InteractionsTable,
    defaultCols: "8",
    maxCols: "12",
    useDateTimePicker: true,
  },
  job_table: {
    component: JobsTable,
    defaultCols: "8",
    maxCols: "12",
    defaultProps: { showHeader: true },
  },
  program_table: {
    component: ProgramTable,
    defaultCols: "8",
    maxCols: "12",
    defaultProps: { showHeader: true },
  },
  people_assigned_resources: {
    component: ResourcesMetric,
    defaultCols: "2",
    maxCols: "3",
    useDateTimePicker: true,
    defaultProps: { metricType: "people" },
  },
  consumables_assigned: {
    component: ResourcesMetric,
    defaultCols: "2",
    maxCols: "3",
    useDateTimePicker: true,
    defaultProps: { metricType: "resources", resourceType: "consumable" },
  },
  nonconsumables_assigned: {
    component: ResourcesMetric,
    defaultCols: "2",
    maxCols: "3",
    useDateTimePicker: true,
    defaultProps: { metricType: "resources", resourceType: "nonconsumable" },
  },
  resource_usage_pct: {
    component: ResourcesMetric,
    defaultCols: "2",
    maxCols: "3",
    useDateTimePicker: true,
    defaultProps: { metricType: "usage" },
  },
  consumables_assigned_table: {
    component: ResourcesAssignedTable,
    defaultCols: "8",
    maxCols: "12",
    useDateTimePicker: true,
    defaultProps: { resourceType: "consumable" },
  },
  nonconsumables_assigned_table: {
    component: ResourcesAssignedTable,
    defaultCols: "8",
    maxCols: "12",
    useDateTimePicker: true,
    defaultProps: { resourceType: "nonconsumable" },
  },
};
